// DEBE IR PRIMERO: inicializa i18next antes de montar React. Los componentes
// piden traducciones en su primer render, asi que si llega tarde pintan la
// clave en bruto durante un instante.
import "./i18n/i18n";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css"; // Para font-bold
import "@fontsource/inter/900.css";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
